<template>
  <div
    class="d-flex flex-column align-center"
    data-qa="core-selection-drawer-error"
  >
    <v-img
      src="/static/_v1/pd/pictures/ui-kit/cancel.svg"
      :alt="t('Ничего не нашлось', options)"
      width="150"
      height="150"
      class="mb-3"
    />
    <div class="text-h6 text--text mb-2">
      {{ t('Что-то пошло не так', options) }}
    </div>
    <div class="text-body-1 text-secondary--text mb-3">
      {{ t('Попробуйте немного подождать и обновите', options) }}
    </div>
    <v-btn
      depressed
      color="primary"
      data-qa="core-selection-drawer-error-btn-reload"
      @click="reloadPage"
    >
      {{ t('Обновить', options) }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed } from 'vue'

const reloadPage = () => window.location.reload()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))
</script>
